module.exports = __webpack_public_path__ + "img/jk4.30310179.jpg";